import { environment } from './environment';

export const ucwords = (str) => {
    return (str + '')
        .replace(/^(.)|\s+(.)/g, function ($1) {
        return $1.toUpperCase()
    });
}

export const premiumPermission = (needed,current) => {
    if (needed === true) {
        if (current > 0) {
            return true;
        } else {
            return false;
        }
    } else {
        if (current >= needed) {
            return true;
        } else {
            return false;
        }
    }
}

export const getEditGameSlug = (lang) => {
    return 'editgame/';
}

export const getCreateSlug = (lang) => {
    switch (lang) {
    case 'es':
        return 'editor-de-recursos/';
    case 'fr':
        return 'editeur-de-ressources/';
    default:
        return 'resource-editor/';
    }
}

export const PREMIUM_ORIGIN_PARAM = 'origin';

export const withPremiumOrigin = (url, origin = null) => {
    if (!origin) {
        return url;
    }
    return url + (url.includes('?') ? '&' : '?') + PREMIUM_ORIGIN_PARAM + '=' + encodeURIComponent(origin);
}

export const getPremiumSlug = (type, origin = null) => {
    let slug;
    switch (type) {
    case 1:
        slug = 'premium/checkout/?id=1';
        break;
    case 2:
        slug = 'premium/checkout/?id=2';
        break;
    case 3:
        slug = 'premium/checkout/?id=3';
        break;
    default:
        slug = 'premium/';
    }
    return withPremiumOrigin(slug, origin);
}

export const getLoginSlug = () => {
    return 'login/';
}

export const deepSpread = (element) => {
    return JSON.parse(JSON.stringify(element));
}

export const setBlockPageScroll = (blocked) => {
    if (blocked) {
        document.documentElement.classList.add('noScroll');
    } else {
        document.documentElement.classList.remove('noScroll');
    }
}

export const extractTextFromHTML = (html) => {
    const temporalDiv = document.createElement("div");
    temporalDiv.innerHTML = html;
    return temporalDiv.textContent || temporalDiv.innerText || "";
};

export const shortenText = ( text, maxLength, separators ) => {
    let response = '';
    if (text.length > maxLength) {
        let position = maxLength;
        let endPosition = false;
        while ((position >= 1) && (endPosition === false)) {
            if (separators.includes(text.substr(position,1))) {
                endPosition = position;
            }
            position--;
        }
        if (endPosition === false) {
            response = text;
        } else {
            response = text.substr(0,endPosition-1) + '...';
        }
    } else {
        response = text;
    }
    return response;
}

const writeCookie = (name, value, maxAge, environmentCookies) => {
    document.cookie = name + '=' + value + '; max-age=' + maxAge + '; path=/; domain=' + environmentCookies + '; secure; SameSite=None';
};

export const setCookie = ( name, value, environmentCookies ) => {
    writeCookie(name, value, 31536000, environmentCookies);
}

export const deleteCookie = (name, environmentCookies) => {
    writeCookie(name, '', 0, environmentCookies);
};

export const getCookie = ( name ) => {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
}

export const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

export const secondsToClock = (seconds) => {
    let mMinute = parseInt(seconds / 60);
    let mSeconds = seconds % 60;
    mMinute = mMinute.toString();
    mSeconds = mSeconds.toString();
    mMinute = mMinute.padStart(2,'0');
    mSeconds = mSeconds.padStart(2,'0');
    return mMinute + ':' + mSeconds;
}

export const getResourceUrl = (activity) => {
    if (environment.isTemporalActivity) {
        return `${environment.files}recursosTemp/${activity.id}/`;
    }
    return `${environment.files}recursos/${activity.resourcesIndex}/${activity.id}/`;
};

// URL del perfil publico de un usuario (ruta userProfile de app.json):
// https://{subdominio}.{entorno}/{usuario|user|utilisateur}/{id}-{slug}/
export const getUserProfileUrl = (id, slug) => {
    const segment = { en: 'user', fr: 'utilisateur' }[environment.lang] || 'usuario';
    return `https://${environment.subdomain}.${environment.entorno}/${segment}/${id}-${slug}/`;
};

// URL publica de un juego para jugarlo (ruta recursos de app.json):
// https://{subdominio}.{entorno}/{recursos-educativos|learning-resources|ressources-pedagogiques}/{id}-{slug}.html
export const getActivityUrl = (id, slug) => {
    const segment = { en: 'learning-resources', fr: 'ressources-pedagogiques' }[environment.lang] || 'recursos-educativos';
    return `https://${environment.subdomain}.${environment.entorno}/${segment}/${id}-${slug}.html`;
};

export const getHash = async (data) => {
    const msgUint8 = new TextEncoder().encode(data);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
}

export const multimediaToBinary = async (multimedia) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = ({ target }) => {
            resolve(new Uint8Array(target.result));
        };
        reader.readAsArrayBuffer(multimedia);
    });
}

// Modelo multimedia por apartado: MULTIMEDIA es un array de entradas { TYPE, SOURCE }.
// Devuelve la entrada del tipo indicado o undefined.
export const getMultimediaEntry = (element, type) => {
    return (element?.MULTIMEDIA ?? []).find((entry) => entry?.TYPE === type);
}

export const hasMultimedia = (element) => {
    return (element?.MULTIMEDIA ?? []).length > 0;
}

// El dataType del guardado lleva dentro el origen (audioTTS, imageLibrary…). El backend lo
// desdobla; aquí solo se necesita el tipo de media para filtrar galerías y slots.
export const getMultimediaTypeFromDataType = (dataType) => {
    return (dataType || '').replace(/(Record|TTS|URL|Library|Bank|Edited)+$/, '');
}

// Marca con el motivo del reuso todas las entradas de un nodo copiado, en profundidad: una
// pregunta duplicada arrastra respuestas con su propia multimedia. Solo es trazabilidad para
// analítica: no cambia nada de cómo se muestra o se juega la media.
export const markMultimediaReuse = (node, reason) => {
    if (Array.isArray(node)) {
        return node.map((item) => markMultimediaReuse(item, reason));
    }
    if ((node === null) || (typeof node !== 'object')) {
        return node;
    }
    const marked = {};
    Object.keys(node).forEach((key) => {
        if (key === 'MULTIMEDIA') {
            marked[key] = Array.isArray(node[key])
                ? node[key].map((entry) => (entry ? { ...entry, REUSE: reason } : entry))
                : node[key];
            return;
        }
        marked[key] = markMultimediaReuse(node[key], reason);
    });
    return marked;
}